import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from './basic/button';
import auth0 from '../services/auth0';
import analytics from '../services/amplitude';

const SocialButton = ({
  backgroundColor,
  backgroundColorHover,
  Icon,
  text,
  connectionName,
  iconColor,
}) => {
  const [disabled, setDisabled] = useState(false);

  return (
    <Button
      disabled={ disabled }
      backgroundColor={ backgroundColor }
      backgroundColorHover={ backgroundColorHover }
      Icon={ Icon }
      text={ text }
      callback={ () => {
        setDisabled(true);
        analytics.trackEvent(analytics.EVENT_NAMES.AUTH, {
          connectionName,
        });
        auth0.continueWithSocial(connectionName)
          .then(() => setDisabled(false));
      } }
      iconColor={ iconColor }
    />
  );
}

SocialButton.propTypes = {
  backgroundColor: PropTypes.string,
  Icon: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  text: PropTypes.string,
  connectionName: PropTypes.string,
  iconColor: PropTypes.string,
  backgroundColorHover: PropTypes.string,
}


export default SocialButton;